import { Controller } from "@hotwired/stimulus"

// The Watching grid: as wide as the page and as tall as it needs. When the
// table fits, nothing scrolls inside it, so its header row sticks to the top
// of the page as you scroll; on a screen too narrow for every store's column,
// it scrolls sideways in its own box instead.
export default class extends Controller {
  connect() {
    this.fit = this.fit.bind(this)
    this.observer = new ResizeObserver(this.fit)
    this.observer.observe(this.element)
    this.fit()
  }

  disconnect() {
    this.observer.disconnect()
  }

  fit() {
    const table = this.element.querySelector("table")
    if (table) this.element.classList.toggle("rw-grid-fits", table.scrollWidth <= this.element.clientWidth + 1)
  }
}
